import React, { useState } from "react";
import { Button, Modal, Tooltip, Row, Tag, Space } from "antd";
import {
  UserAddOutlined,
  InfoOutlined,
  InfoCircleTwoTone,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { actions as loginActions } from "views/Auth/Login/redux";
import { appTypeSelector } from "App/OfflineApp/offlineAppSelectors";
import { actions as offlineAppActions } from "App/OfflineApp/offlineAppRedux.js";
import { actions as fireStoreReduxActions } from "views/Experiences/ExperienceShow/FirestoreInteractions/redux";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const QuitBtnChromeOS = (props) => {
  const [visible, setVisible] = useState(false);
  const mrIntl = useTranslate()

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = (e) => {
    setVisible(false);
  };

  const handleCancel = (e) => {
    setVisible(false);
  };

  return <>
    <Button danger type="primary" onClick={showModal}>
    {mrIntl("CommonText.quit")}
    </Button>
    <Modal
      // title="Assessment details"
      open={visible}
      footer={null}
      onOk={handleOk}
      onCancel={handleCancel}
      width={800}
      wrapClassName="experience-info-modal"
    >
      <Row className={"m-t-15"}>
        <Space>
          <span>To quit AssessPrep, press the power button and click on sign out.</span>
        </Space>
      </Row>

    </Modal>
  </>
}


const QuitBtn = (props) => {
  const { withLog, userInfo = {} } = props;

  const dispatch = useDispatch();
  const appType = useSelector(appTypeSelector());
  let quitBtn = "";
  const [loading, setLoading] = useState(false);
  const mrIntl = useTranslate()

  if (appType == "seb") {
    quitBtn = (
      <Button
        danger
        type="primary"
        onClick={() => {
          withLog && props.action &&
            dispatch(
              fireStoreReduxActions.setUserInfo(
                userInfo,
                {
                  log: {
                    logging: true,
                    action: props.action,
                  },
                }
              )
            );
        }}
        href={`${process.env.REACT_APP_WEB_URL}/seb_quit.html`}
      >
        {mrIntl("CommonText.quit")}
      </Button>
    );
  }

  if (appType == "mac" || appType == "ios") {
    quitBtn = (
      <Button
        loading={loading}
        danger
        type="primary"
        onClick={() => {
          setLoading(true);
          withLog && props.action &&
            dispatch(
              fireStoreReduxActions.setUserInfo(
                userInfo,
                {
                  log: {
                    logging: true,
                    action: props.action,
                  },
                }
              )
            );
          setTimeout(
            () => {
              dispatch(
                offlineAppActions.executeMethod([
                  // {
                  //   key: "clearCache",
                  //   value: true,
                  // },
                  {
                    key: "quit",
                    value: true,
                  },
                ])
              );
              setLoading(false);
            },
            withLog ? 1500 : 0
          );
        }}
      >
        {mrIntl("CommonText.quit")}
      </Button>
    );
  }

  if (appType == "cros") {
    quitBtn = <QuitBtnChromeOS />
      // quitBtn = <h5>To quit AssessPrep, press the power button on your keyboard and click on Sign out.</h5>
    }

  return quitBtn;
};

export default QuitBtn;
